export default "__VITE_ASSET__DbqUd8i3__"